export default {
  process: {
    title: 'Process Time',
    settingsTitle: 'Processing settings',
    employeesTitle: 'Employees and processing period',
    company: 'Company',
    type: 'Process type',
    daily: 'I/O + Daily allowance',
    monthly: 'Monthly allowance',
    employees: 'Employee codes',
    employeesHelp:
      'Separate codes with a new line or comma. At least one employee is required.',
    date: 'Work date',
    currentPeriod: 'Monthly uses the selected company’s current pay period.',
    review: 'Review and confirm',
    invalid: 'Enter employee codes and a valid work date for I/O + Daily.',
    processing: 'Processing. Please wait; do not submit again.',
    latest: 'Latest result',
    confirmation: 'Confirm processing',
    employeeCount: 'Employees ({{count}})',
    confirmNote:
      'This action may update existing I/O and allowance data. OT queue admission does not mean OT processing is complete.',
    cancel: 'Cancel',
    confirm: 'Confirm processing',
    status: {
      completed: 'Completed',
      partial: 'Partial',
      'no-data': 'No data',
      rejected: 'Rejected',
      unknown: 'Outcome unknown'
    },
    dailyCompleted:
      'I/O and Daily allowance processing completed. OT was queued; OT completion is not yet confirmed.',
    monthlyCompleted: 'Monthly allowance processing completed.',
    monthlyNoData: 'No monthly allowance records met the criteria.',
    dailyNoData: 'No I/O records met the existing processing criteria.',
    noSource:
      'No Time requests or raw/store data matched the employees and work date.',
    queueFailed:
      'I/O and Daily allowance were committed, but OT queue admission failed. Check saved data and logs before processing again.',
    rowErrors:
      'Some rows did not produce I/O. Check saved data before processing again.',
    employeeMismatch: 'Every employee must belong to the selected company.',
    employeeAmbiguous:
      'This employee code is shared by multiple companies. Processing was rejected because the current shift lookup cannot distinguish the company.',
    periodMissing: 'No pay period covers this date for the selected company.',
    rejectedMessage:
      'The request was rejected. Check permissions, employees, company and pay period.',
    unknownMessage:
      'The final outcome is unknown. Data may already have been saved. Check the saved data and logs before submitting again; no automatic retry will run.'
  },
  title: 'E-Time',
  home: 'Home',
  tabs: {
    process: 'Process',
    time: 'Time',
    'special-allowance': 'Special-allowance',
    import: 'Import',
    export: 'Export'
  },
  'table-branch': {
    title: 'E-Time branches',
    description: 'Manage E-Time settings for each branch.',
    company: 'Company {{company}}',
    branches: 'Branches',
    action: 'Action',
    'edit-settings': 'Edit settings',
    'add-button': 'Add branch',
    id: 'id',
    branchCode: 'Branch code',
    describe: 'Describe'
  },
  'table-special-allowance': {
    title: 'Special allowance',
    description: 'Manage allowance codes and their minimum and maximum values.',
    company: 'Company {{code}}',
    'list-title': 'Allowance settings',
    edit: 'Edit allowance',
    delete: 'Delete allowance',
    id: 'id',
    code: 'Allowance code',
    name: 'Allowance name',
    costCenterName: 'Cost center name',
    'add-button': 'Add special allowance',
    min: 'Min value',
    max: 'Max value',
    action: 'Action'
  },
  'main-setting': {
    modal: {
      add: 'Add {{type}} condition',
      edit: 'Edit {{type}} condition',
      'ot-permission': 'Allow approver to edit OT time'
    },
    'branch-information': 'Branch information',
    'add-title': 'Add E-Time branch settings',
    'company-code': 'Company code',
    'branch-code': 'Branch code',
    'branch-help':
      'Use the branch code from the employee system, such as BANGKOK. Saving only adds E-Time settings; it does not create a branch in the employee system.',
    'main-workflow': 'Main approval workflow',
    'main-workflow-help':
      'Used when a request does not match any division or department condition below.',
    'add-condition': 'Add division or department condition',
    'condition-required':
      'Select at least a division or department and an approval workflow.',
    'condition-duplicate':
      'This division and department condition already exists.',
    required: 'This field is required.',
    duplicate: 'This branch code already has settings in the company.',
    'save-error': 'Unable to save. Please check the settings and try again.',
    'access-denied':
      'You do not have permission to add E-Time branch settings.',
    'edit-title': 'Edit main setting',
    'sub-title': { ot: 'OT setting', time: 'Time setting' },
    form: {
      enableCardMapping: 'Enable card mapping',
      enableAppEditTime: 'Enable approver can edit time',
      division: 'Division',
      department: 'Department',
      workflowCode: 'Workflow code'
    }
  },
  form: {
    'sp-allowance': {
      'add-title': 'Add special allowance',
      'edit-title': 'Edit special allowance',
      description:
        'Set allowance details, value limits and the approval workflow.',
      information: 'Allowance information',
      approval: 'Cost center and approval workflow',
      code: {
        label: 'Allowance code'
      },
      name: {
        label: 'Allowance name'
      },
      minCost: {
        label: 'Min value'
      },
      maxCost: {
        label: 'Max value'
      },
      costCenterCode: {
        label: 'Cost Center'
      },
      workflowCode: {
        label: 'Workflow'
      }
    }
  }
}
